import { useEffect, useState } from 'react';

import Grid from '@material-ui/core/Grid';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import TablePagination from '@mui/material/TablePagination';
import { Button, Table, Text } from 'components';
import { Field, Form, Formik } from 'formik';
import { PageTitle } from 'pages/Layout/PageTitle';
import { registerService } from 'services/register';

import { DialogConfirm } from './Dialog/DialogConfirm';
import { DialogEdit } from './Dialog/DialogEdit';
import { DialogRegister } from './Dialog/DialogRegister';

const columns = [
  { label: 'Produto' },
  { label: 'Tipo Produto' },
  { label: 'Marca' },
  { label: 'Modelo' },
  { label: 'Cor' },
  { label: 'Alterar' },
  { label: 'Ativar/Desativar' },
];

export const RegisterProduct = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [openDialogRegister, setOpenDialogRegister] = useState(false);
  const [openDialogEdit, setOpenDialogEdit] = useState(false);
  const [openDialogConfirm, setOpenDialogConfirm] = useState(false);
  const [table, setTable] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [line, setLine] = useState();
  const [searchValue, setSearchValue] = useState('');

  // Get Data
  const fetchData = async () => {
    const { data } = await registerService.findProducts();
    setTable(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Dialogs
  const handleOpenDialogRegister = () => {
    setOpenDialogRegister(true);
  };

  const handleCloseDialogRegister = () => {
    setOpenDialogRegister(false);
    fetchData();
  };

  const handleOpenDialogEdit = (item) => {
    setLine(item);
    setOpenDialogEdit(true);
  };

  const handleCloseDialogEdit = () => {
    setOpenDialogEdit(false);
    fetchData();
  };

  const handleOpenDialogConfirm = (item) => {
    setLine(item);
    setOpenDialogConfirm(true);
  };

  const handleCloseDialogConfirm = () => {
    setOpenDialogConfirm(false);
    fetchData();
  };

  // Paginação
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    setPage(0);
  }, [searchValue]);

  return (
    <>
      <DialogConfirm
        handleCloseDialogConfirm={handleCloseDialogConfirm}
        openDialogConfirm={openDialogConfirm}
        line={line}
      />
      <DialogRegister
        handleCloseDialogRegister={handleCloseDialogRegister}
        openDialogRegister={openDialogRegister}
      />
      <DialogEdit
        handleCloseDialogEdit={handleCloseDialogEdit}
        openDialogEdit={openDialogEdit}
        line={line}
      />
      <PageTitle>Cadastro de Produtos</PageTitle>
      <Formik initialValues={{ search: '' }}>
        {(props) => (
          <Form>
            <Grid container spacing={2} alignItems='center'>
              <Grid item xs={3} md={3} lg={3}>
                <Button fullWidth loading={isLoading} onClick={handleOpenDialogRegister}>
                  Cadastrar
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Field
                  variant='outlined'
                  name='search'
                  label='Pesquisar'
                  size='small'
                  component={Text}
                  fullWidth
                  onChange={(event) => setSearchValue(event.target.value.toLowerCase())}
                />
              </Grid>
            </Grid>
            <Box mt={2}>
              <Table name='Table' headers={columns} maxHeight disableNumeration>
                {table
                  .filter(
                    (item) =>
                      item.descricao.toLowerCase().includes(searchValue) ||
                      item.idTipoProduto.descricao.toLowerCase().includes(searchValue) ||
                      item.idMarca.descricao.toLowerCase().includes(searchValue) ||
                      item.idModel.descricao.toLowerCase().includes(searchValue) ||
                      item.cor.toLowerCase().includes(searchValue),
                  )
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.descricao}</TableCell>
                      <TableCell>{item.idTipoProduto.descricao}</TableCell>
                      <TableCell>{item.idMarca.descricao}</TableCell>
                      <TableCell>{item.idModel.descricao}</TableCell>
                      <TableCell>{item.cor}</TableCell>
                      <TableCell>
                        <EditIcon
                          style={{ color: '#512da8', cursor: 'pointer' }}
                          fullWidth
                          onClick={() => handleOpenDialogEdit(item)}
                        />
                      </TableCell>
                      <TableCell>
                        {(item.ativo === true && (
                          <Grid container>
                            <Grid item xs={12} md={4}>
                              <Button
                                color='secondary'
                                fullWidth
                                onClick={() => handleOpenDialogConfirm(item)}
                              >
                                Desativar
                              </Button>
                            </Grid>
                          </Grid>
                        )) ||
                          (item.ativo === false && (
                            <Grid container>
                              <Grid item xs={12} md={4}>
                                <Button fullWidth onClick={() => handleOpenDialogConfirm(item)}>
                                  Ativar
                                </Button>
                              </Grid>
                            </Grid>
                          ))}
                      </TableCell>
                    </TableRow>
                  ))}
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component='div'
                count={table.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Box>
          </Form>
        )}
      </Formik>
    </>
  );
};
